import React from 'react';

function HomeComResume() {
  const imageUrl = `${process.env.PUBLIC_URL}/Documents/myresume.jpg`;

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '90%', width: '100%',paddingTop:'18px' }}>
      <img src={imageUrl} alt="Resume" style={{ width: '99%', height: 'auto', maxWidth: '100%' }} />
    </div>
  );
}

export default HomeComResume;
